// extracted by mini-css-extract-plugin
export var box = "Item-module--box--c42ae";
export var box_md = "Item-module--box_md--4873d";
export var box_xmd = "Item-module--box_xmd--ffd24";
export var box_flex = "Item-module--box_flex--6eac4";
export var box_lg = "Item-module--box_lg--3d44c";
export var box_sm = "Item-module--box_sm--e9622";
export var box_outer = "Item-module--box_outer--47918";
export var box_whiteBg = "Item-module--box_white-bg--ee23e";
export var box_noMarginBottom = "Item-module--box_no-margin-bottom--360ad";
export var box_noPadding = "Item-module--box_no-padding--c8069";
export var box_outerGray = "Item-module--box_outer-gray--c89df";
export var box_dark = "Item-module--box_dark--ece06";
export var box_zIndex = "Item-module--box_z-index--9d29f";
export var box_zIndex6 = "Item-module--box_z-index-6--137be";
export var box_eventsWithLine = "Item-module--box_events-with-line--faacd";
export var box_featuresAo = "Item-module--box_features-ao--3470f";
export var box_verticalPaddings = "Item-module--box_vertical-paddings--0ac52";
export var clearP = "Item-module--clearP--46378";
export var clearP_vc = "Item-module--clearP_vc--cc5a5";
export var gridItems = "Item-module--gridItems--2ccf3";
export var grow = "Item-module--grow--985d4";
export var hidden = "Item-module--hidden--e2d6d";
export var fadeInAnimation = "Item-module--fadeInAnimation--126b3";
export var placeHolderShimmer = "Item-module--placeHolderShimmer--46d68";